import React from "react";
import PillarsSection from "./PillarsSection";
import { BarsIcon, BriefcaseIcon, BookIcon } from "./icons";

const SPECIALTIES = [
  {
    icon: <BookIcon />,
    title: "Controle Contábil",
    text: "Elaboração de demonstrações financeiras, conciliações e relatórios para apoiar decisões empresariais seguras.",
  },
  {
    icon: <BarsIcon />,
    title: "Gestão Fiscal",
    text: "Apuração de impostos, entrega de declarações e acompanhamento das exigências fiscais para conformidade e redução de riscos.",
  },
  {
    icon: <BriefcaseIcon />,
    title: "Suporte Legal",
    text: "Abertura, alteração de empresas e regularizações cadastrais para o correto funcionamento do seu negócio.",
  },
];

// Seção "Soluções Completas para o seu Negócio" (página de Serviços).
// O id="especialidades" permite que o botão "Conheça Nossos Pilares" do
// PageHero role até aqui via âncora (#especialidades).
export default function Specialties() {
  return (
    <PillarsSection
      id="especialidades"
      eyebrow="Nossas Especialidades"
      title="Soluções Completas para o seu Negócio"
      text="Oferecemos suporte técnico e consultivo nas áreas cruciais para a saúde e expansão da sua empresa."
      items={SPECIALTIES}
    />
  );
}
